var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "finish-enter", style: { height: _vm.viewportHeight } },
    [
      _c("HomeHeader", { attrs: { "scroll-top": "300" } }),
      _c("div", { staticClass: "flex-column container w-wrapper" }, [
        _c("div", { staticClass: "flex-column main" }, [
          _c("div", { staticClass: "title" }, [_vm._v("企业MCN机构申请")]),
          _c(
            "div",
            { staticClass: "steps-box" },
            [
              _c(
                "el-steps",
                { attrs: { active: 5, "align-center": "" } },
                [
                  _c("el-step", { attrs: { title: "选择公会类型" } }),
                  _c("el-step", { attrs: { title: "填写公会信息" } }),
                  _c("el-step", { attrs: { title: "填写资质信息" } }),
                  _c("el-step", { attrs: { title: "确认信息" } }),
                  _c("el-step", { attrs: { title: "等待审核" } }),
                  _c("el-step", { attrs: { title: "完成入驻" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "flex-column-center form-box" }, [
            _c("img", {
              staticClass: "img-status",
              attrs: {
                src: require("@/assets/apply/submit-success.png"),
                alt: "",
              },
            }),
            _vm.applyDetail.status === 4
              ? _c(
                  "div",
                  {
                    staticClass: "title-status",
                    staticStyle: { color: "#f56c6c" },
                  },
                  [_vm._v("您的申请已被驳回")]
                )
              : _c("div", { staticClass: "title-status" }, [
                  _vm._v("完成入驻"),
                ]),
            _vm.applyDetail.status === 4
              ? _c("div", { staticClass: "dec" }, [
                  _vm._v("驳回原因：" + _vm._s(_vm.applyDetail.reason)),
                ])
              : _c("div", { staticClass: "dec" }, [
                  _vm._v("资料审核通过，您成功入驻火乐园MCN"),
                ]),
            _c("div", { staticClass: "flex-row-h-center edit-btn" }, [
              _vm.applyDetail.status === 4
                ? _c(
                    "div",
                    { staticClass: "mr20" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "default" },
                          on: {
                            click: function ($event) {
                              return _vm.onChangeInfo()
                            },
                          },
                        },
                        [_vm._v("修改资料")]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.onLoginOrg()
                            },
                          },
                        },
                        [_vm._v("前往登录")]
                      ),
                    ],
                    1
                  ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }